// @ts-nocheck

import React from 'react';


import { vehicleIssueGroupApi } from '../../lib/api';

import AutocompleteSelect from './AutocompleteSelect';


export default (props) =>
<AutocompleteSelect
  placeholder="Выберите группу дефектов"
  fetch={vehicleIssueGroupApi.fetchVehicleIssueGroup}
  fetchSingle={vehicleIssueGroupApi.getVehicleIssueGroup}
  notFoundText="Пользователи не найдены"
  renderOption={(vehicleIssueGroup, Option) =>
  <Option
    value={vehicleIssueGroup.id}
    key={vehicleIssueGroup.id}
    vehicleIssueGroup={vehicleIssueGroup}>

        {vehicleIssueGroup.name}
      </Option>
  }
  {...props} />;
